import React, {useState} from "react"
import {Button, Card, Col, Descriptions, Row, Typography, notification} from "antd"
import {OrganizationLDAPTable} from "./OrganizationLDAPTable"
import {AddLDAPServerDialog} from "../components/AddLDAPServerDialog"
import {LDAPServerInfo} from "../../../models/ldap-server-info"
import {useId24} from "../../../drivers/id24/Id24Provider"
import {LDAPServerService} from "../../../services/ldap-server-service"

const { Title } = Typography

export const OrganizationSettings: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24()
  const [addLdapServerVisible, setAddLdapServerVisible] = useState(false)

  const ldapServerService = LDAPServerService(id24Axios())

  const onAddLDAPServer = (ldapServerInfo: LDAPServerInfo) => {
    console.log(`onFormSubmit ${JSON.stringify(ldapServerInfo, null, 2 )}`)
    ldapServerService
      .addLdapServer(ldapServerInfo)
      .then(() => {
        setAddLdapServerVisible(false)
        notification.success({
          message: "LDAP Server Added"
        })
      })
      .catch((_error) => {
        notification.error({
          message: _error.message
        })
      })
  }

  return <>
    <Row>
      <Col>
        <Title>Organization settings</Title>
      </Col>
    </Row>

    <Row>
      <Col span="24">
        <Card>
          <Descriptions title="Organization name" bordered style={{ textAlign: "left" }}>
            <Descriptions.Item label="LDAP Servers" span={3}>
              <Row justify="end">
                <Col>
                  <Button
                    style={{ marginLeft: 10 }}
                    type="primary"
                    onClick={() => setAddLdapServerVisible(true)}
                  >
                    + Add LDAP Server
                  </Button>
                </Col>
              </Row>
              <OrganizationLDAPTable/>
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
    </Row>
    <AddLDAPServerDialog
      visible={addLdapServerVisible}
      onAdd={(ldapServerInfo) => onAddLDAPServer(ldapServerInfo) }
      onClose={() => setAddLdapServerVisible(false)}
    />
  </>
}